var $78c0c0c4796561ef$exports = {};
$78c0c0c4796561ef$exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};


export {$78c0c0c4796561ef$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
